/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.forms.modals.confirm.controllers', [])

.controller('FormsModalsConfirmController', ['$scope', '$uibModalInstance', 'message', function($scope, $uibModalInstance, message) {

    $scope.formsModalsConfirm = {

      message: message,

      init: function() {},

      cancel: function() {
        $uibModalInstance.dismiss('close');
      },

      done: function() {
        $uibModalInstance.close();
      }

    };

    $scope.formsModalsConfirm.init();

}]);